import Image from "./Image";
const COBRAND_SRC = "/logos/products/rentshield-inshur-white.svg";
/* RentShield lockup pinned to the card's top-left corner, with the scroll-in shimmer.
   `cobrand` swaps in the RentShield + INSHUR lockup; the shimmer mask follows the artwork. */
export function RentShieldCardLogo({ cobrand = false }) {
    if (cobrand) {
        return (<div className="absolute left-6 top-6 z-20 h-12 w-auto sm:left-8 sm:top-8 sm:h-16">
        <Image src={COBRAND_SRC} alt="RentShield with INSHUR" width={193} height={65} className="h-full w-auto object-contain"/>
        <span aria-hidden="true" className="ai-logo-shimmer" style={{ WebkitMaskImage: `url("${COBRAND_SRC}")`, maskImage: `url("${COBRAND_SRC}")` }}>
          <span className="ai-logo-shimmer__sheen"/>
        </span>
      </div>);
    }
    return (<div className="absolute left-6 top-6 z-20 h-16 w-auto sm:left-8 sm:top-8 sm:h-20">
      <Image src="/logos/products/rentshield-white.png" alt="RentShield" width={233} height={107} className="h-full w-auto object-contain"/>
      <span aria-hidden="true" className="ai-logo-shimmer">
        <span className="ai-logo-shimmer__sheen"/>
      </span>
    </div>);
}
